import type { AcademyState } from './types';

export const demoState: AcademyState = {
  academyName: 'Harbour Jiu-Jitsu Academy',
  coachName: 'Coach Maya',
  students: [
    { id: 'student-1', name: 'Alex Morgan', belt: 'Blue', stripes: 2, attendance90: 27, streakWeeks: 4, progressions: [{ id: 'progress-1', belt: 'Blue', stripes: 2, awardedOn: '2026-08-12', note: 'Consistent technical growth.' }] },
    { id: 'student-2', name: 'Sam Nkosi', belt: 'White', stripes: 3, attendance90: 29, streakWeeks: 3, progressions: [] },
    { id: 'student-3', name: 'Jordan Lee', belt: 'Purple', stripes: 1, attendance90: 21, streakWeeks: 4, progressions: [{ id: 'progress-3', belt: 'Purple', stripes: 1, awardedOn: '2026-06-21' }] },
    { id: 'student-4', name: 'Casey Jacobs', belt: 'White', stripes: 1, attendance90: 16, streakWeeks: 2, progressions: [] },
  ],
  sessions: [
    {
      id: 'session-1',
      title: 'Evening Gi — Fundamentals',
      startsAt: new Date(Date.now() - 15 * 60 * 1000).toISOString(),
      endsAt: new Date(Date.now() + 45 * 60 * 1000).toISOString(),
      discipline: 'class',
      attendance: {},
    },
  ],
  posts: [
    {
      id: 'post-1',
      author: 'Sam Nkosi',
      academyName: 'Harbour Jiu-Jitsu Academy',
      title: 'Guard retention rounds',
      body: 'Three rounds after class. Working on staying calm and rebuilding inside position from bottom mount.',
      activityType: 'sparring',
      durationMinutes: 24,
      media: [{ id: 'media-1', type: 'image', url: 'https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=1200&q=80', position: 0 }],
      likeCount: 12,
      commentCount: 3,
      likedByMe: false,
      reason: 'From your academy',
      createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: 'post-2',
      author: 'Alex Morgan',
      academyName: 'Harbour Jiu-Jitsu Academy',
      title: 'Key moment: knee-cut defence',
      body: 'Reviewing when I gave up the underhook. The second attempt was much cleaner.',
      activityType: 'drilling',
      durationMinutes: 35,
      analysisNotes: 'At 00:18, pause before the pass and keep the near elbow connected to the knee. Rebuild the frame before turning in.',
      keyMomentSeconds: 18,
      media: [{ id: 'media-2', type: 'video', url: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4', position: 0 }],
      likeCount: 8,
      commentCount: 2,
      likedByMe: true,
      reason: 'Your activity',
      createdAt: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    },
  ],
};
